var MuiSnackbar = {
    /* put your new default props here */
    anchorOrigin: { vertical: 'top', horizontal: 'center' },
};
export default MuiSnackbar;
//# sourceMappingURL=MuiSnackbar.js.map